<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Açıklama
    </div>
    <template v-if="dataModal.dataItem.notes">
      <div>{{ dataModal.dataItem.notes }}</div>
    </template>
    <template v-else>
      <div class="text-muted">
        Belirtilemdi
      </div>
    </template>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'NotesText',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
}
</script>
